import React from 'react';
import PropTypes from 'prop-types';

import { SHARE_BLOCK_MODAL } from '../../../constants/modals';
import { getAsset } from '../../../util/assets';
import withModal from '../modal/withModal';
import Button from '../Button';
import Emoji from '../Emoji';

const propTypes = {
  onRequestClose: PropTypes.func.isRequired,
};

const ShareBlockModal = ({ onRequestClose }) => {
  return (
    <div className="share-block-modal-content">
      <img
        className="share-block-image mt-2"
        src={getAsset('/share-block.png')}
        alt="share block"
      />
      <h3 className="mt-2">
        No social post request <Emoji label="pray" emoji="🙏" />
      </h3>
      <p>
        Someone in this photo has requested this photo not be posted to social
        media. Thank you for respecting their privacy.
      </p>

      <Button onClick={onRequestClose} className="mt-3">
        OK
      </Button>
    </div>
  );
};

ShareBlockModal.propTypes = propTypes;

export default withModal(ShareBlockModal, {
  className: 'share-block-modal',
  hideHeader: true,
  name: SHARE_BLOCK_MODAL,
  size: 'sm',
});
